import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_DYNAMIC_VARIABLE,
  CREATE_DYNAMIC_VARIABLE_VALUE,
  DELETE_DYNAMIC_VARIABLE,
  DELETE_DYNAMIC_VARIABLE_VALUE,
  GET_DYNAMIC_VARIABLES,
  GET_DYNAMIC_VARIABLE_VALUES,
  UPDATE_DYNAMIC_VARIABLE_TITLE,
} from 'setup/redux/Actions/DynamicVariable/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_DYNAMIC_VARIABLES, fetchData)
  yield takeEvery(GET_DYNAMIC_VARIABLE_VALUES, fetchData)
  yield takeEvery(CREATE_DYNAMIC_VARIABLE, fetchData)
  yield takeEvery(UPDATE_DYNAMIC_VARIABLE_TITLE, fetchData)
  yield takeEvery(DELETE_DYNAMIC_VARIABLE, fetchData)
  yield takeEvery(CREATE_DYNAMIC_VARIABLE_VALUE, fetchData)
  yield takeEvery(DELETE_DYNAMIC_VARIABLE_VALUE, fetchData)
}

export default dataSaga
